import OrganizationStructuredData from '@/components/seo/organization-json-ld';
import { useSettings } from '@/framework/settings';
import { isSearchEngineIndexableDeployment } from '@/lib/canonical-site';
import { defaultOgImageUrl, isUsableImageUrl } from '@/lib/seo/og-image';
import { DEFAULT_META_DESCRIPTION, HOME_META_TITLE } from '@/lib/seo/site-copy';
import { DefaultSeo as NextDefaultSeo } from 'next-seo';

const DefaultSeo = () => {
  const { settings }: any = useSettings();
  const allowIndexing = isSearchEngineIndexableDeployment();
  const brand = 'Qualidoc';
  const ogImage = isUsableImageUrl(settings?.seo?.ogImage)
    ? settings.seo.ogImage
    : defaultOgImageUrl();

  return (
    <>
      <NextDefaultSeo
        dangerouslySetAllPagesToNoIndex={!allowIndexing}
        dangerouslySetAllPagesToNoFollow={!allowIndexing}
        additionalMetaTags={[
          {
            name: 'viewport',
            content:
              'width=device-width, initial-scale=1, viewport-fit=cover',
          },
        ]}
        additionalLinkTags={[
          {
            rel: 'apple-touch-icon',
            href: '/icons/icon512_rounded.png',
          },
        ]}
        titleTemplate={`%s | ${brand}`}
        defaultTitle={`${HOME_META_TITLE} | ${brand}`}
        description={
          settings?.seo?.metaDescription ||
          settings?.siteSubtitle ||
          DEFAULT_META_DESCRIPTION
        }
        // No global canonical — each page sets its own via <Seo url=...>.
        openGraph={{
          title: settings?.seo?.ogTitle || `${HOME_META_TITLE} | ${brand}`,
          description:
            settings?.seo?.ogDescription ||
            settings?.seo?.metaDescription ||
            DEFAULT_META_DESCRIPTION,
          type: 'website',
          locale: 'pt_BR',
          site_name: settings?.siteTitle || 'Qualidoc',
          images: [
            {
              url: ogImage,
              alt: settings?.seo?.ogTitle || 'Qualidoc',
            },
          ],
        }}
        twitter={{
          handle: settings?.seo?.twitterHandle,
          site: settings?.siteTitle || 'Qualidoc',
          cardType: settings?.seo?.twitterCardType || 'summary_large_image',
        }}
      />
      <OrganizationStructuredData />
    </>
  );
};

export default DefaultSeo;
